import { Button } from "antd";
import HBModel from ".";
import styles from "./info.module.less";
import ModalWrap from "./ModalWrap";
// import HBIcon from "../HBIcon";

function RawHBInfo({
  content,
  title = "提示",
  onOk,
  okText,
  okButtonProps,
  cancelText,
  cancelButtonProps,
  onCancel,
  onCancelBtnClick,
  hideOkBtn = false,
  hideCancelBtn = false,
  ...props
}) {
  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      width={400}
      onCancel={onCancel}
    >
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{content}</div>
      <div className={styles.footer}>
        {!hideCancelBtn && (
          <Button
            width="40"
            onClick={() => {
              onCancel && onCancel();
              onCancelBtnClick && onCancelBtnClick();
            }}
            style={{ marginRight: "8px" }}
            {...(cancelButtonProps || {})}
          >
            {cancelText || "取消"}
          </Button>
        )}
        {!hideOkBtn && (
          <Button
            width="40"
            type={"primary"}
            onClick={() => {
              onOk && onOk();
            }}
            {...(okButtonProps || {})}
          >
            {okText || "确认"}
          </Button>
        )}
      </div>
    </HBModel>
  );
}

const HBInfoDialog = ModalWrap(RawHBInfo);
export default HBInfoDialog;
